<div
  id="summary-promotion"
  class="summary-row promotion"
  [class.saved-cart]="savedCart === true"
  *ngIf="
    ((potentialPromotions != null && potentialPromotions.length > 0) ||
      (appliedOrderPromotions != null && appliedOrderPromotions.length > 0)) &&
    !showSrp
  "
>
  <div class="summary-label" *ngFor="let promotion of potentialPromotions">
    <mat-icon svgIcon="promotion"></mat-icon> <span [innerHTML]="promotion.description"> </span>
  </div>

  <div class="summary-label" *ngFor="let appliedPromotion of appliedOrderPromotions">
    <ng-container *ngIf="appliedPromotion.promotion.description">
      <mat-icon svgIcon="promotion"></mat-icon>
      <span [innerHTML]="appliedPromotion.promotion.description"> </span>
    </ng-container>
  </div>
</div>
